export default __webpack_public_path__ + "static/media/logo.9e83f20c.png";